import { isMaintenanceError } from './maintenance';

// A 4xx means the request itself is wrong — replaying it verbatim produces the
// exact same response forever. Only transport failures (no response) and 5xx are
// worth another attempt. Without this an unconditional `onReject: () => reload()`
// turns one bad request into an unbounded loop against the API.
// A maintenance 503 lasts minutes, not a blip: KoobMaintenanceGate tells the
// user instead.
export const isRetryableError = (error) => {
  if (isMaintenanceError(error)) return false;
  const status = error?.response?.status;
  return status === undefined || status >= 500;
};
